"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SortDirection = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Cell = _interopRequireDefault(require("./Cell"));
var _SortIndicator = _interopRequireDefault(require("../SortIndicator"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "dynamic_data_table-module__container___XBKGO",
  "table": "dynamic_data_table-module__table___KPe4Z",
  "header": "dynamic_data_table-module__header___InOJk",
  "hidden_scroll": "dynamic_data_table-module__hidden_scroll___smZMg",
  "cell": "dynamic_data_table-module__cell___WmECs",
  "title": "dynamic_data_table-module__title___xRq1r",
  "body": "dynamic_data_table-module__body____WpZz",
  "wrapper": "dynamic_data_table-module__wrapper___6vpz9",
  "inner": "dynamic_data_table-module__inner___DWRAj",
  "row": "dynamic_data_table-module__row___mJOCH",
  "even": "dynamic_data_table-module__even___s9yJX dynamic_data_table-module__row___mJOCH",
  "odd": "dynamic_data_table-module__odd___QReWF dynamic_data_table-module__row___mJOCH",
  "sortable": "dynamic_data_table-module__sortable___y8wPA",
  "no_wrap": "dynamic_data_table-module__no_wrap___hv7Wl",
  "custom_no_data": "dynamic_data_table-module__custom_no_data___qSxqC",
  "msg": "dynamic_data_table-module__msg___dAka6",
  "msg_icon": "dynamic_data_table-module__msg_icon___CBpqN",
  "no_rows": "dynamic_data_table-module__no_rows___DABRw dynamic_data_table-module__msg___dAka6",
  "fetching": "dynamic_data_table-module__fetching___Udqx5 dynamic_data_table-module__msg___dAka6",
  "ellipsis": "dynamic_data_table-module__ellipsis___GMwo_",
  "highlight": "dynamic_data_table-module__highlight___VP4U1",
  "actions": "dynamic_data_table-module__actions___geMKG",
  "tooltip": "dynamic_data_table-module__tooltip___iNmbQ",
  "copy": "dynamic_data_table-module__copy___ua22X"
};
const SORT_DIR_ASC = 'ASC';
const SORT_DIR_DESC = 'DESC';
const SortDirection = exports.SortDirection = (0, _freeze.default)({
  up: SORT_DIR_ASC,
  down: SORT_DIR_DESC
});
const Header = /*#__PURE__*/_react.default.memo(props => {
  var _context, _context2;
  const units = (0, _react.useContext)('units');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.header,
    role: "header row"
  }, (0, _map.default)(_context = (0, _filter.default)(_context2 = props.columns).call(_context2, column => column.display)).call(_context, column => {
    const {
      property,
      label,
      unitType,
      unitLabel,
      sortable
    } = column;
    const sortEnabled = !props.sortDisabled && !!sortable;
    const sorted = sortEnabled && props.sortBy === property;
    const sortDirection = SortDirection[props.sortDirection];
    const columnProps = {
      role: "header column"
    };
    if (sortEnabled) {
      const newDirection = !sorted || sortDirection === SORT_DIR_DESC ? 'up' : 'down';
      columnProps['aria-label'] = props.ariaLabel || label || property;
      columnProps.tabIndex = 0;
      columnProps.onClick = () => props.onClick(property, newDirection);
      if (sorted) {
        columnProps['aria-sort'] = sortDirection === SORT_DIR_DESC ? 'descending' : 'ascending';
      }
    }
    columnProps.className = (0, _classnames.default)({
      [styles.sortable]: sortEnabled
    }, props.headerClassName, column.headerClassName);
    return /*#__PURE__*/_react.default.createElement(_Cell.default, (0, _extends2.default)({}, columnProps, {
      key: `header_${property}`,
      style: column.style
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.title,
      title: label
    }, label), unitType && unitLabel && /*#__PURE__*/_react.default.createElement("span", {
      className: styles.units
    }, units[unitType][unitLabel]), sorted && /*#__PURE__*/_react.default.createElement(_SortIndicator.default, {
      sortDirection: sortDirection
    }));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.hidden_scroll
  }));
});
Header.propTypes = {
  columns: T.arrayOf(T.shape({
    display: T.bool,
    style: T.object
  })).isRequired,
  sortBy: T.string,
  sortDirection: T.oneOf((0, _keys.default)(SortDirection)),
  onClick: T.func
};
var _default = exports.default = Header;